import React, { useState } from "react";
import "@/App.css";
import { LanguageProvider } from "@/contexts/LanguageContext";
import LoadingScreen from "@/components/site/LoadingScreen";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Hours from "@/components/site/Hours";
import Reviews from "@/components/site/Reviews";
import Location from "@/components/site/Location";
import OfferUp from "@/components/site/OfferUp";
import About from "@/components/site/About";
import Footer from "@/components/site/Footer";

function Site() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="App grain min-h-screen bg-[#0a0a0a] text-white" data-testid="app-root">
      <LoadingScreen onFinish={() => setLoaded(true)} />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Hours />
        <Reviews />
        <About />
        <OfferUp />
        <Location />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}
